import { useGlobalState } from "../../providers/globalState/GlobalStateProvider";
import { useStaticText } from "../../providers/staticText/staticTextProvider";
import ProgressBar from "./progressBar";

function Header() {
  const { showLogo, currentTitle, showProgressBar, progressBarValue, currentStep } = useGlobalState()
  const { name } = useGlobalState()
  const { getStaticText } = useStaticText()

  const hideLogoText = currentStep === "start" || currentStep === "gender" || currentStep === "language";

  return (
    <header>
      {showProgressBar ? (<ProgressBar progress={progressBarValue} />) : ""}
      {showLogo ? (
        <div className={`top ${hideLogoText ? 'icon-only' : ''}`}>
          <img className='logo-img' src="https://cdn-eu.lolaenglish.com/LangAvatar.webp" alt="" />
          {!hideLogoText && <p>LangArena</p>}
        </div>
      ) : ""}
      {currentTitle && (
        <h1 className={currentStep === "choosePlan" ? 'header-choose-plan' : ""}>
          {currentTitle}
        </h1>
      )}
    </header>
  );
}


export default Header;